export enum PriceLookupKey {
	STRIPE_OLD_MONTHLY_PLAN_AMOUNT = 1999,
	STRIPE_OLD_YEARLY_PLAN_AMOUNT = 19900,
}

/**
 * Stripe prices every new individual member is offered: $39/month and
 * $399/year, shipped from the October 2026 price test.
 */
export const MEMBERSHIP_PRICE_IDS = {
	month: "2026_october_price_39",
	year: "2026_october_year_price_399",
} as const;

/**
 * October 2026 test prices that are no longer offered. Members already on
 * them keep their subscription.
 */
export const RETIRED_MEMBERSHIP_PRICE_IDS = new Set<string>([
	"2026_october_price_35",
	"2026_october_year_price_349",
]);

/** Pricing-model name sent with checkouts in the joining-price test. */
export const MEMBERSHIP_JOINING_PRICE_MODEL = "joining_fee";

/** Arms of the joining-price test, in flag order. */
export const MEMBERSHIP_JOINING_PRICE_VARIANTS = [
	"control",
	"joining_69",
	"joining_99",
] as const;

export type JoiningPriceVariant =
	(typeof MEMBERSHIP_JOINING_PRICE_VARIANTS)[number];

/**
 * One-time USD fee, in cents, added to the first monthly payment so it totals
 * $69 or $99 with the $39 month. Control has no fee.
 */
export const MEMBERSHIP_JOINING_FEE_CENTS = {
	joining_69: 3000,
	joining_99: 6000,
} as const satisfies Partial<Record<JoiningPriceVariant, number>>;

/** Subscription metadata key holding a fee still owed when a trial ends. */
export const JOINING_FEE_METADATA_KEY = "joiningFeeAmount";

/**
 * @param {unknown} value - Untrusted variant, e.g. from a flag or request body
 * @returns {boolean} True when the value is a joining-price arm
 */
export const isJoiningPriceVariant = (
	value: unknown,
): value is JoiningPriceVariant =>
	typeof value === "string" &&
	(MEMBERSHIP_JOINING_PRICE_VARIANTS as readonly string[]).includes(value);
